<template>
    <div>
                
                    <div style="overflow-y: auto; width:100%; height:560px; display: block; padding-right:10px; padding-top:10px; padding-left:10px;">
                        <div v-if="!bookingSent">
                                <v-form   
                                    ref="form"
                                    v-model="valid"
                                    :lazy-validation="lazy"
                                >

                                <div style="">
                                    <v-text-field
                                    autocomplete="off"
                                    @keyup.native="defineSearchField('from')"
                                    outlined
                                    dense
                                    label="Från"
                                    hint="Vart åker du ifrån?"
                                    clearable
                                    v-model="from"
                                    number
                                    light
                                    color="#33308b"
                                    class="custom-label-color"
                                    :rules="rulesFrom"
                                    >
                                    </v-text-field>
                                    <div id="result" v-if="searchResult">
                                        <v-simple-table >
                                            <template v-slot:default>
                                            <tbody>
                                                <tr v-for="(data, i) in searchResult" :key="i">
                                                    <td @click="setPlaceName(data.place_name,'from',data.id,data.geometry)">{{ data.place_name }}</td>
                                                </tr>
                                            </tbody>
                                            </template>
                                        </v-simple-table>
                                    </div>
                                </div>
                                <div style="">
                                    <v-text-field
                                    autocomplete="off"
                                    outlined
                                    dense
                                    label="Till"
                                    id="to"
                                    hint="Vart vill du åka?"
                                    @keyup.native="defineSearchField('to')"
                                    clearable
                                    v-model="to"
                                    number
                                    light
                                    color="#33308b"
                                    class="custom-label-color"
                                    :rules="rulesTo"
                                    >
                                    </v-text-field>
                                    <div id="result2" v-if="searchResult2">
                                        <v-simple-table >
                                            <template v-slot:default>
                                            <tbody>
                                                <tr v-for="(data, i) in searchResult2" :key="i">
                                                    <td @click="setPlaceName(data.place_name,'to',data.id,data.geometry)">{{ data.place_name }}</td>
                                                </tr>
                                            </tbody>
                                            </template>
                                        </v-simple-table>
                                    </div>
                                </div>
                                <div style="margin-left:10px; margin-top:-25px;">
                                   <v-switch
                                    v-model="flight"
                                    inset
                                    label="Resa till/från flyg"
                                    ></v-switch>
                                </div>
                                <div v-if="flight" style="display:flex;">
                                    <v-text-field style="width:60%; flex: 40%;"
                                    outlined
                                    label="Flight nr"
                                    clearable
                                    v-model="flightNumber"
                                    number
                                    light
                                    dense
                                    color="#33308b"
                                    class="custom-label-color"
                                    :rules="flightNrRules"
                                   
                                    >
                                    </v-text-field>
                                    <v-switch style="width:55%; flex: 20%; margin-left:60px; margin-top:5px; margin-right:10px;"
                                    v-model="sharedCar"
                                    inset
                                    label="Delad bil?"
                                    ></v-switch>

                                </div>
                                <div>
                                    <v-select
                                    v-if="!flight"
                                    v-model="travelWhen"
                                    :items="travelWhenOptions"
                                    label="När vill du resa?"
                                    dense
                                    outlined
                                    ></v-select>
                                </div>
                                <div>
                                <div>
                                    <v-slider
                                    :disabled="changePassengerDisabled"
                                    v-model="totalPassenger"
                                    label="Antal passagerare?"
                                    hint="Hur många passagerare?"
                                    max="8"
                                    min="1"
                                    thumb-label="always"
                                    ticks="always"
                                    tick-size="1"
                                    color="#33308b"
                                    ></v-slider>
                                </div>
                                <div style="float:left;" v-if="!sharedCar">
                                    <b>Uppskattad kostnad:</b> {{totalcost}} kr
                                </div>
                                <br><br>
                                </div>

                                <div style="" v-if="travelWhen == 'Resa senare' || flight">
                                    <v-datetime-picker 
                                    :textFieldProps="{outlined: true, dense: true, locale: 'sv-se'}" 
                                    :timePickerProps="{'format': '24hr', 'class': 'elevation-0'}" 
                                    :datePickerProps="{flat: true, 'class': 'elevation-0'}" 
                                    okText="Spara"
                                    clearText="Avbryt"	
                                    label="Välj datum och tid" 
                                    v-model="dateTime"
                                    :rules="dateTimeRules"
                                    > 
                                    
                                    </v-datetime-picker>
                                </div>

                                <div style="">
                                    <v-text-field
                                    outlined
                                    label="Ditt namn"
                                    clearable
                                    v-model="name"
                                    number
                                    light
                                    dense
                                    color="#33308b"
                                    class="custom-label-color"
                                    :rules="rulesName"
                                    >
                                    </v-text-field>
                                </div>
                                <div style="">
                                    <v-text-field
                                    outlined
                                    dense
                                    label="Ditt telefonnummer"
                                    clearable
                                    v-model="phoneNumber"
                                    number
                                    light
                                     color="#33308b"
                                    class="custom-label-color"
                                    :rules="rulesTextField"
                                   
                                    >
                                    </v-text-field>
                                </div>
                                <div style="" v-if="travelWhen == 'Resa senare'">
                                    <v-text-field
                                    outlined
                                    dense
                                    label="Din e-post"
                                    clearable
                                    v-model="email"
                                    number
                                    light
                                    color="#33308b"
                                    class="custom-label-color"
                                    :rules="rulesEmail"
                                    >
                                    </v-text-field>
                                </div>

                                <div style="margin-bottom:20px;">
                                    <v-btn color="green" style="color:white !important;" x-large :disabled="!valid" block  class="text-white"  @click="submitBooking()">Boka</v-btn>
                                </div>
                                
                                </v-form>
                        </div>
                        <div v-else >
                            <div v-if="travelWhen == 'Resa nu'">
            
                                <Chat :booking="bookingObject" :user="user" />
                            
                            </div>
                            <div v-else>
                             <h3>Tack för din beställning!</h3><br>
                                <div>

                                <v-card
                                    width="100%"
                                    class="mx-auto"
                                >

                                <v-simple-table>
                                    <template v-slot:default>
                                    <thead>
                                        <tr>
                                        <th class="text-left">
                                            
                                        </th>
                                        <th>
                                            Bekräftelse på bokning
                                        </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                        v-for="item in viewReceipt"
                                        :key="item.text"
                                        >
                                        <td class="text-left" style="width:20px; padding-right:0px; padding-left:10px;"><i class="material-icons">{{item.icon}}</i></td>
                                        <td class="text-left">{{ item.text }}</td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                                </div>
                            </div>
                        </div>
                    </div>
    </div>
</template>
<script>
import moment from 'moment';
import Chat from './Chat'
export default {
    props: ['user'],
    data() {
        return {
            viewReceipt: [],
            totalcost: 0,
            reciept: '',
            searchResult2: [],
            searchResult: [],
            mapboxClient: Object,
            bookingObject: Object,
            bookingSent: false,
            changePassengerDisabled: false,
            travelWhen: 'Resa nu',
            dateTime: '',
            flightNumber: '',
            sharedCar: false,
            name: '',
            email: '',
            totalPassenger: 1,
            travelWhenOptions: ['Resa nu', 'Resa senare'],
            toGeo: [],
            to: '',
            fromGeo: [],
            from: '',
            flight: false,
            addCallbackVerified: true,
            valid: false,
            phoneNumber: '',
            message: '',
            value: '',
            lazy: false,
            flightNrRules: [v => v.length > 2 || 'Måste innehålla mer än 2 tecken', v => !!v || 'Du måste skriva något.'],
            rulesName: [v => v.length <= 160 || 'Max 160 ord.', v => !!v || 'Du måste skriva något.'],
            rulesEmail: [v => !!v || 'Du måste skriva en e-post', v => /.+@.+\..+/.test(v) || 'E-posten är inte korrekt.',],
            rulesTextField: [v => v.length <= 160 || 'Max 160 ord.', v => !!v || 'Du måste skriva något.', v => v.length > 5 || 'Du måste skriva minst 5 tecken.', ],
            rulesFrom: [v => v.length <= 160 || 'Max 160 ord.', v => !!v || 'Skriv in en address.'],
            rulesTo: [v => v.length <= 160 || 'Max 160 ord.', v => !!v || 'Skriv in en address.'],
            dateTimeRules: [v => v.length > 5 || 'Måste innehålla mer än 5 tecken', v => !!v || 'Du måste skriva något.'],
            finalRoute: []
        }
    },
    components: {
        Chat,
    },
    watch: {
        sharedCar(val) {
            
            if(val) {
                this.totalPassenger = 1;
                this.changePassengerDisabled = true;
            } else {
                this.changePassengerDisabled = false;
            }
        },
        totalPassenger(val) {
            if(this.toGeo.length > 0 && this.fromGeo.length > 0) {
                this.calculateCost(this.fromGeo,this.toGeo);
            }
        },
        to(val) {
            if(val == null) {
                this.totalcost = 0;
            }
        },
        from(val) {
            if(val == null) {
                this.totalcost = 0;
            }
        }

    },
    mounted() {

    if (localStorage.getItem("visitorInfo") !== null) {
        this.email = JSON.parse(localStorage.getItem('visitorInfo')).visitorEmail;
    }

        
        this.mapboxClient = mapboxSdk({ accessToken: 'pk.eyJ1IjoidGFpZWJraGVzc2liIiwiYSI6ImNraDluYzFhbTBia3EyeWxoMjZ1dnoxNjIifQ.hDG0z99keigiD79U2D6LgQ' });
    },
    filters: {
        momentWithData: function (date) {
            return moment(date).format('YYYY-MM-DD HH:mm');
        }
    },
    methods: {

    addVisitorInfo() {

      this.visitorInfo = {
        visitorEmail: this.email,
        visitorClientNumber: '',
        visitorId: localStorage.getItem('visitorId')
      }
      localStorage.setItem("visitorInfo", JSON.stringify(this.visitorInfo));


    },

        calculateCost(from,to) {
    
            this.mapboxClient.directions.getDirections({
            profile: 'driving',
            waypoints: [
                {
                    coordinates: from,
                },
                {
                    coordinates: to
                },
            ]
            })
            .send()
            .then(response => {
                const directions = response.body;                
                this.calculateFormula(response.body.routes,this.totalPassenger);
            });


        },
        calculateFormula(route,passengers) {

            const duration = route[0].duration / 60;
            const distance = route[0].distance / 1000;

            let startCost = 0;
            let kmCost = 0;
            let hourPrice = 0;

            if(passengers >= 1 && passengers <= 4) {
                startCost = 60;
                kmCost = 12;
                hourPrice = 660;
            }
            if(passengers >= 5 && passengers <= 6) {
                startCost = 96;
                kmCost = 16;
                hourPrice = 722;
            }
            if(passengers >= 7 && passengers <= 8) {
                startCost = 130;
                kmCost = 16;
                hourPrice = 722;
            }

            const finalFormula = (startCost)+(kmCost*distance)+((hourPrice/60)*duration);
            this.totalcost = Math.round(finalFormula* 1.02);

            // (Startavgift)+(kmpris*antalkm)+((timpris/60)*antal minuter)
            /* 
            1-4 passagerare                          (60)+(12*antalkm)+((660/60)*antalminuter)
            5-6 passagerare                          (96)+(16*antalkm)+((722/60)*antalminuter)
            7-8 passagerare                          (130)+(16*antalkm)+((722/60)*antalminuter)
            */

        },
        setPlaceName(name,type,id,geo) {

            this.searchResult = []
            this.searchResult2 = []
            if(type == 'from') {
                this.fromGeo = geo.coordinates;
                this.from = name;
            }
            if(type == 'to') {
                this.toGeo = geo.coordinates;
                this.to = name;
            }
            if(this.toGeo.length > 0 && this.fromGeo.length > 0) {
                this.calculateCost(this.fromGeo,this.toGeo);
            }

            this.checkIfAirport(id);
            

        },
        defineSearchField(type) {
            let query = '';
            if(type == 'from') {
                query = this.from;
            }
            if(type == 'to') {
                query = this.to;
            }
            this.search(query,type)
        },
        search(query,type) {
         
            if(query.length < 1) {
                this.searchResult = [];
                this.searchResult2 = [];
                return;
            }

            this.mapboxClient.geocoding.forwardGeocode({
                query: `'${query}'`,
                limit: 10,
                countries: ['se'],
                language: ['se'],
                types: ['address','poi'],
                //proximity: [64.75067,20.95279],
                bbox: [14.625568306531534,64.16777912996153,21.206179148284008,66.17763226972443],
                /*types: ['address','region'], */
                autocomplete: true,
            }).send()
            .then(response => {

                // Special case mapbox show rosgatan with Ö.
                response.body.features[0].place_name = response.body.features[0].place_name.split('Rösgatan').join('Rosgatan')
                response.body.features[0].place_name = response.body.features[0].place_name.split(', Västerbotten').join('');
                response.body.features[0].place_name = response.body.features[0].place_name.split(', SE').join('');
           
                const match = response.body;
                if(type == 'from') { 
                    this.searchResult = match.features;
                }
                if(type == 'to') { 
                    this.searchResult2 = match.features;
                }
            });

        },
        checkIfAirport(id) {
                if(id == 'poi.1108101584045') {
                    this.flight = true;
                }
        },
        moment: function () {
            return moment();
        },
        submitBooking() {
            
            const visitorId = localStorage.getItem("visitorId");
            let topic = 'Ny bokning från widget';
            let type = 'newCase'
            let convertedDate = '';

            if(this.flight) {
                this.travelWhen = 'Resa senare';
            }

            if(this.travelWhen == 'Resa nu') {
                type = 'newChat'
                topic = 'Kund vill resa nu - Ny bokning från widget'
                convertedDate = this.moment().format('YYYY-MM-DD HH:mm');          
            } else {
                convertedDate = this.$options.filters.momentWithData(this.dateTime); 
            }  

            let description = `<h4>Bokningsdetaljer:</h4>
<b>Res från:</b> ${this.from} <br>
<b>Till:</b> ${this.to} <br>
<b>När:</b> ${convertedDate}<br>
<b>Passagerare:</b> ${this.totalPassenger}<br>
<b>Uppskattad kostnad:</b> ${this.totalcost} kr<br> 
<br><br>
<b>Uppgifter från resnär:</b><br>
<b>Namn</b> ${this.name} <br>
<b>Tele</b> ${this.phoneNumber} <br>
<b>Delad bil</b> ${this.sharedCar === true ? 'Ja' : 'Nej'} <br>
<b>Flygresa:</b> ${this.flight === true ? 'Ja' : 'Nej'}<br>
<b>Ev flyg nr:</b> ${this.flightNumber}<br>
            `;

            if(this.travelWhen == 'Resa nu') {
                description = description.replace(/<[^>]*>?/gm, '');
            }


            this.reciept = description;

            this.viewReceipt = [
                {
                    text: 'Reser från:' + this.from,
                    icon: 'add_location'
                },
                {
                    text: 'Till: ' + this.to,
                    icon: 'add_location_alt',
                },
                {
                    text: 'När: ' + convertedDate,
                    icon: 'access_time'
                },
                {
                    text: 'Passagerare: ' + this.totalPassenger,
                    icon: 'person_pin'
                },
                {
                    text: 'Uppskattad kostnad: '+ this.totalcost + ' kr',
                    icon: 'attach_money'
                },
                {
                    text: 'Delad bil? ' + this.sharedCar === true ? 'Delad bil: Ja' : 'Delad bil: Nej',
                    icon: 'local_taxi'
                },
                {
                    text: this.flight === true ? 'Flygresa: Ja' : 'Flygresa: Nej',
                    icon: 'flight'
                },
                {
                    text: 'Flyg nr: '+ this.flightNumber,
                    icon: 'flight'
                },
            ]
            
            this.bookingObject = {
                description: description,
                to: this.to,
                froms: this.from,
                from: 'client',
                flightTrip: this.flight,
                flightNumber: this.flightNumber,
                sharedCard: this.sharedCar,
                totalPassenger: this.totalPassenger,
                type: type,
                topic: topic,
                booking: true,
                dateTime: this.dateTime,
                fromAgent: false,
                agentUserId: 0,
                category: 'Bokning',
                visitorInfo: {
                    name: this.name,
                    email: this.email,
                    visitorEmail: this.email || visitorId,
                    visitorId: visitorId,
                    bookedFrom: 'computer',
                    geoLocation: {
                        lat: '',
                        long: ''
                    }
                },
            }
       

            if(this.travelWhen == 'Resa nu') {
                this.bookingSent = true;
          
            } else {

                this.$store.dispatch('submitCase', this.bookingObject).then(data => {
                    this.bookingSent = true;
                    this.addVisitorInfo();
                }).catch(err => {
                    this.bookingSent = false;
                    console.log(err)
                });

            }
            
        },
        addCallback(userId, email) {

            const visitorId = localStorage.getItem("visitorId");
            const dataToSend = {
                userId: userId, 
                message: this.message, 
                visitorInfo: { visitorEmail: this.phoneNumber },
                type: 'email',
                visitorId: visitorId,
                agentEmail: email
            }
        
            this.$store.dispatch('sendCallback', dataToSend);

            this.addCallbackVerified = false;
            let self = this;
            setTimeout(() => {
                self.addCallbackVerified = true;
                self.callbackCall(userId)
            }, 5000);

        },

    }

}
</script>

<style lang="scss" scoped>

.theme--light.v-input.search-field input::placeholder {
  color: green;
}

$width: 25px;
$height: $width;
$color: #21a5f7;
$bounce-height: 80px;
$bounce-width: 3; // float, suggested 0-3
$bounce-duration: 0.6s;
$shadow-strength: 0.08;

.loading-wrapper {
    margin-top:15px;
    font-size:20px;
}

.loader {
  width: $width;
  height: $height;
  background-color: $color;
  border-radius: $width + $height;
  position: absolute;
  animation: bounce $bounce-duration linear infinite, move $bounce-duration * 6 linear infinite $bounce-duration / 2.5;
}

.loader-shadow {
  width: $width / 2;
  height: 0;
  margin-left: ($width / 4);
  background-color: rgba(0,0,0,0.2);
  box-shadow: 0 0 ($width / 10) 1px rgba(0,0,0,$shadow-strength);
  border-radius: $width $height;
  position: absolute;
  animation: move $bounce-duration * 6 linear infinite $bounce-duration / 2.5;
}

@keyframes bounce {
  0% {
    bottom: 0;
    animation-timing-function: ease-out;
  }
  50% {
    bottom: $bounce-height;
    animation-timing-function: ease-in;
  }
  100% {
    bottom: 0;
  }
}

@keyframes move {
  0% {
    transform: translateX($width * $bounce-width * -1);
  }
  16.666% {
    transform: translateX($width * $bounce-width * -0.3333);
  }
  33.3333% {
    transform: translateX($width * $bounce-width * 0.3333);
  }
  50% {
    transform: translateX($width * $bounce-width * 1);
  }
  66.6666% {
    transform: translateX($width * $bounce-width * 0.3333);
  }
  83.333% {
    transform: translateX($width * $bounce-width * -0.3333);
  }
  100% {
    transform: translateX($width * $bounce-width * -1);
  }
}

.loader-container {
  bottom: 50%;
  left: 50%;
  position: absolute;
}


.loading {
    color:black;
}

.loading:after {
  content: ' .';
  animation: dots 1s steps(5, end) infinite;}

@keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: black;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  }
</style>